import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { notificationsFetch, notificationUpdate } from '../../../../../../redux/actions/NotificationActions';
import { Box, IconButton, makeStyles, Popover, Tooltip, useTheme } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import NotificationsIcon from '@material-ui/icons/Notifications';
import CmtCardHeader from '../../../../../../@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '../../../../../../@coremat/CmtCard/CmtCardContent';
import CmtList from '../../../../../../@coremat/CmtList';
import CmtCard from '../../../../../../@coremat/CmtCard';
import NotificationItem from './NotificationItem';
import PerfectScrollbar from 'react-perfect-scrollbar';
import clsx from 'clsx';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';
import IntlMessages from '@jumbo/utils/IntlMessages';
import _ from 'lodash';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 4,
      paddingBottom: 4,
    },
    '& .Cmt-card-content': {
      padding: '0 0 16px !important',
    },
  },
  typography: {
    padding: theme.spacing(2),
  },
  iconRoot: {
    position: 'relative',
    color: alpha(theme.palette.common.white, 0.9),
    '&:hover, &.active': {
      color: theme.palette.common.white,
    },
  },
  counterRoot: {
    color: theme.palette.common.white,
    border: `solid 1px ${theme.palette.common.white}`,
    backgroundColor: theme.palette.warning.main,
    width: 20,
  },
  scrollbarRoot: {
    height: 300,
    padding: 16,
  },
  popoverRoot: {
    '& .MuiPopover-paper': {
      width: 375,
    },
  },
}));

const HeaderNotifications = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const authUser = useSelector(({ auth: { authUser } }) => authUser);
  const notifications = useSelector(({ notification: { notifications } }) => notifications);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [counter, setCounter] = React.useState(0);
  const [timerID, setTimerID] = React.useState(null);
  const theme = useTheme();

  useEffect(() => {
    if (authUser && authUser._id) {
      if (timerID == null) {
        const id = setInterval(() => {
          dispatch(notificationsFetch({ receiver: authUser._id, limit: '25' }));
        }, 10000);
        setTimerID(id);
      }
      return () => {
        setTimerID(null);
        clearInterval(timerID);
      };
    }
  }, [authUser]);

  useEffect(() => {
    if (authUser && authUser._id) {
      let unreads = _.filter(notifications, o => !o.reader.includes(authUser._id));
      setCounter(unreads.length);
    }
  }, [notifications]);

  const actions = [
    {
      label: intl.formatMessage({ id: 'notification.closed' }),
      onClick: () => {
        onClosePopOver();
      },
    },
  ];

  const onOpenPopOver = event => {
    setAnchorEl(event.currentTarget);
    setCounter(0);
    // UPDATE NOTIFICATION
    if (authUser && authUser._id) {
      let unreads = _.filter(notifications, o => !o.reader.includes(authUser._id));
      unreads.forEach(element => {
        element.reader.push(authUser._id);
        dispatch(notificationUpdate({ _id: element._id, reader: element.reader }));
      });
    }
  };

  const onClosePopOver = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box pr={2}>
      <Tooltip title={`${intl.formatMessage({ id: 'notification' })}`}>
        <IconButton
          onClick={onOpenPopOver}
          className={clsx(classes.iconRoot, 'Cmt-appIcon', {
            active: counter > 0,
          })}>
          <Badge badgeContent={counter} classes={{ badge: classes.counterRoot }}>
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        className={classes.popoverRoot}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClosePopOver}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <CmtCard className={classes.cardRoot}>
          <CmtCardHeader
            title={`${intl.formatMessage({ id: 'notification' })}`}
            actionsPos="top-corner"
            actions={actions}
            separator={{
              color: theme.palette.borderColor.dark,
              borderWidth: 1,
              borderStyle: 'solid',
            }}
          />
          <CmtCardContent>
            {notifications.length > 0 ? (
              <PerfectScrollbar className={classes.scrollbarRoot}>
                <CmtList data={notifications} renderRow={(item, index) => <NotificationItem key={index} item={item} />} />
              </PerfectScrollbar>
            ) : (
              <Box p={6}>
                <Typography variant="body2">
                  <IntlMessages id="errors.data.notfound" />
                </Typography>
              </Box>
            )}
          </CmtCardContent>
        </CmtCard>
      </Popover>
    </Box>
  );
};

export default HeaderNotifications;
